module.exports = __webpack_public_path__ + "img/sold-data-card.48627b2.jpg";